import { Modal } from "./Modal"
import React, { Fragment } from "react"
import L10n from "../../../lib/carrot-l10n"
import Accordion from "components/views/Accordion"
import { HR, Spacer } from "../atoms/Atoms"
import { CenteredLayout } from "../atoms/Layouts"
import { Body } from "../atoms/Bodies"
import { getBenefitConfiguration } from "../../../reducers/benefitConfiguration"
import { useSelector } from "react-redux"
import { H2 } from "@carrotfertility/carotene"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const WhatYouShouldIncludeSections = [
  {
    title: l`client.reimbursements.include.fertilityCare`,
    items: [
      {
        title: l`client.reimbursements.include.fertilityCare.eligibleClinic`,
        body: l`client.reimbursements.include.fertilityCare.eligibleClinic.content`
      },
      {
        title: l`client.reimbursements.include.fertilityCare.eligibleDoctor`,
        body: l`client.reimbursements.include.fertilityCare.eligibleDoctor.content`
      },
      {
        title: l`client.reimbursements.include.fertilityCare.prescribedMedications`,
        body: l`client.reimbursements.include.fertilityCare.prescribedMedications.content`
      },
      {
        title: l`client.reimbursements.include.fertilityCare.cryobankServices`,
        body: l`client.reimbursements.include.fertilityCare.cryobankServices.content`
      }
    ]
  },
  {
    title: l`client.reimbursements.include.adoption`,
    filter: (c) => c.coverageConfig.isAdoptionEnabled,
    items: [
      {
        title: l`client.reimbursements.include.adoption.eligibleAgency`,
        body: l`client.reimbursements.include.adoption.eligibleAgency.content`
      },
      {
        title: l`client.reimbursements.include.adoption.notEligibleAgency`,
        body: l`client.reimbursements.include.adoption.notEligibleAgency.content`
      }
    ]
  },
  {
    title: l`client.reimbursements.include.gestationalCarrier`,
    filter: (c) => c.coverageConfig.isGcEnabled,
    items: [
      {
        title: l`client.reimbursements.include.gestationalCarrier.eligibleAgency`,
        body: l`client.reimbursements.include.gestationalCarrier.eligibleAgency.content`
      },
      {
        title: l`client.reimbursements.include.gestationalCarrier.eligibleEscrow`,
        body: l`client.reimbursements.include.gestationalCarrier.eligibleEscrow.content`
      },
      {
        title: l`client.reimbursements.include.gestationalCarrier.travelExpenses`,
        body: l`client.reimbursements.include.gestationalCarrier.travelExpenses.content`
      },
      {
        title: l`client.reimbursements.include.gestationalCarrier.otherExpenses`,
        body: l`client.reimbursements.include.gestationalCarrier.otherExpenses.content`
      }
    ]
  }
]

const WhatYouShouldIncludeModal = ({ onClose }) => {
  const benefitConfiguration = useSelector(getBenefitConfiguration)
  return (
    <Modal titleText={l`client.reimbursements.include.whatShouldYouInclude`} onExit={onClose}>
      <CenteredLayout>
        <div className="mw6">
          <H2>{l`client.reimbursements.include.whatShouldYouInclude`}</H2>
          <Spacer height={1} />
          <Body>{l`client.reimbursements.include.toProcessQuickly`}</Body>
          <Spacer height={2} />
          <div>
            {WhatYouShouldIncludeSections.map(({ title, items, filter }) => {
              if (filter && !filter(benefitConfiguration)) {
                return null
              }
              return (
                <Fragment key={title}>
                  <HR color="black-10" />
                  <Spacer height={1} />
                  <H2>{title}</H2>
                  <Spacer height={2} />
                  {items.map(({ title, body }) => (
                    <Accordion title={title} body={body} key={title} />
                  ))}
                  <Spacer height={2} />
                </Fragment>
              )
            })}
          </div>
        </div>
      </CenteredLayout>
    </Modal>
  )
}

export default WhatYouShouldIncludeModal
